// AppsFlyer stubs for web platform
// These are no-ops since AppsFlyer is mobile-only

// Module-level state (unused on web)
const attributionData: Record<string, unknown> = {};

/**
 * Initialize AppsFlyer SDK (no-op on web)
 */
export function start(): void {
  // AppsFlyer is not available on web
}

/**
 * Log an event to AppsFlyer (no-op on web)
 */
export function logEvent(_eventName: string, _eventValues: object): void {
  // AppsFlyer is not available on web
}

/**
 * Update user ID for AppsFlyer (no-op on web)
 */
export function updateUser(_userId: string): void {
  // AppsFlyer is not available on web
}

/**
 * Set up install conversion data listener (no-op on web)
 */
export function onInstallConversionData(
  _onData?: (data: Record<string, unknown>) => void,
): void {
  // AppsFlyer is not available on web
}

/**
 * Get stored attribution data (empty on web)
 */
export function getAttributionData(): Record<string, unknown> {
  return attributionData;
}
